import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

const useIsBinderDisabled = (isDisabled: boolean = false) => {
  return useFormBinderDisabled('homePersonalForm', isDisabled);
};

export default useIsBinderDisabled;
